const API_HOST = process.env.VUE_APP_API_HOST || "https://api.tardstation.com";
const SITE_HOST = process.env.VUE_APP_SITE_HOST || "https://tardstation.com";

export const PROVIDER_API_URL = `${API_HOST}/provider-api/v1/`;
export const GENERAL_API_URL = `${API_HOST}/general-api/v1/`;
export const SITE_REGISTER_URL = `${SITE_HOST}/register`;
